import React, { Suspense, lazy, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import TicketStatistics from './pages/TicketStatistics';
import DailyTicketReport from './pages/DailyTicketReport';
import './App.css';
import { LoadingProvider } from './context/LoadingContext';
import { NotificationProvider } from './context/NotificationContext';
import LoadingSpinner from './components/LoadingSpinner/LoadingSpinner';
import ErrorBoundary from './components/ErrorBoundary/ErrorBoundary';
import QRScanner from './components/QRScanner/QRScanner';
import QRResult from './components/QRResult/QRResult';
import DriverCheckin from './pages/DriverCheckin';
import ShiftReport from './pages/ShiftReport';
import Review from './pages/Review';
import ProtectedRoute from './components/ProtectedRoute/ProtectedRoute';
import { requestNotificationPermission, handleTokenRefresh } from './utils/notification';
import UpdatePrompt from './components/UpdatePrompt/UpdatePrompt';
import QRCodeMealClaim from './pages/QRCodeMealClaim';

// Lazy load các components
const Dashboard = lazy(() => import('./pages/Dashboard'));
const NotificationList = lazy(() => import('./pages/NotificationList'));
const UserProfile = lazy(() => import('./pages/UserProfile'));

function App() {
  useEffect(() => {
    const initializeNotifications = async () => {
      try {
        // Chỉ xin quyền, không lưu token
        const permissionResult = await requestNotificationPermission(false);
        
        if (permissionResult.success) {
          const cleanup = handleTokenRefresh();
          return () => {
            if (cleanup) cleanup();
          };
        }
      } catch (error) {
        console.error('Lỗi khởi tạo notification:', error);
      }
    };

    const user = localStorage.getItem('user');
    if (user) {
      initializeNotifications();
    }
  }, []);

  return (
    <ErrorBoundary>
      <LoadingProvider>
        <NotificationProvider>
          <Router>
            <Suspense fallback={<LoadingSpinner />}>
              <Routes>
                <Route path="/" element={<Login />} />
                <Route path="/qr-scanner" element={<QRScanner />} />
                <Route path="/qr-result" element={<QRResult />} />
                <Route path="/qr-meal-claim" element={<QRCodeMealClaim />} />
                <Route path="/notifications" element={<NotificationList />} />
                <Route
                  path="/dashboard"
                  element={
                    <ProtectedRoute>
                      <Dashboard />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/profile"
                  element={
                    <ProtectedRoute>
                      <UserProfile />
                    </ProtectedRoute>
                  }
                />
                <Route path="/ticket-statistics" element={<TicketStatistics />} />
                <Route path="/daily-tickets" element={<DailyTicketReport />} />
                <Route path="/driver-checkin" element={<DriverCheckin />} />
                <Route path="/shift-report" element={<ShiftReport />} />
                <Route path="/feedback" element={<Review />} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </Suspense>
            <UpdatePrompt />
          </Router>
        </NotificationProvider>
      </LoadingProvider>
    </ErrorBoundary>
  );
}

export default App;
